/* Blob.js
 * A Blob implementation.
 * 2018-01-12
 *
 * By Eli Grey, http://eligrey.com
 * By Devin Samarin, https://github.com/dsamarin
 * License: MIT
 *   See https://github.com/eligrey/Blob.js/blob/master/LICENSE.md
 */

/*global self, unescape */
/*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
  plusplus: true */

/*! @source http://purl.eligrey.com/github/Blob.js/blob/master/Blob.js */

(function (view: any): void {
	"use strict";

	view.URL = view.URL || view.webkitURL;

	if (view.Blob && view.URL) {
		try {
			new Blob;
			return;
		} catch (e) {}
	}

	// Internally we use a BlobBuilder implementation to base Blob off of
	// in order to support older browsers that only have BlobBuilder
	let BlobBuilder = view.BlobBuilder || view.WebKitBlobBuilder || view.MozBlobBuilder || (function(view: any) {
		let
			  get_class: (object: any) => string = function(object: any): string {
				// @ts-ignore
				  return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
			}
			, FakeBlobBuilder: () => void = function BlobBuilder(): void {
				// @ts-ignore
				this.data = [];
			}
			, FakeBlob: (data: any, type: any, encoding: any, fake?: any) => void = function Blob(data: any, type: any, encoding: any, fake: any): void {
				// @ts-ignore
				this.data = data;
				// @ts-ignore
				this.size = data.length;
				// @ts-ignore
				this.type = type;
				// @ts-ignore
				this.encoding = encoding;
				// @ts-ignore
				this.fake = fake;
			}
			, FBB_proto: any = FakeBlobBuilder.prototype
			, FB_proto: any = FakeBlob.prototype
			, FileReaderSync: any = view.FileReaderSync
			, FileException: (type: any) => void = function(type: any): void {
				// @ts-ignore
			     this.code = this[this.name = type];
			}
			, file_ex_codes: string[] = (
				  "NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR "
				+ "NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR"
			).split(" ")
			, file_ex_code: number = file_ex_codes.length
			, real_URL: any = view.URL || view.webkitURL || view
			, real_create_object_URL: any = real_URL.createObjectURL
			, real_revoke_object_URL: any = real_URL.revokeObjectURL
			, URL: any = real_URL
			, btoa: (data: string) => string = view.btoa
			, atob: (data: string) => string = view.atob

			, ArrayBuffer: ArrayBuffer = view.ArrayBuffer
			, Uint8Array: any = view.Uint8Array

			, origin: RegExp = /^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/
		;
		// @ts-ignore
		FakeBlob.fake = FB_proto.fake = true;
		while (file_ex_code--) {
			// @ts-ignore
			FileException.prototype[file_ex_codes[file_ex_code]] = file_ex_code + 1;
		}
		// Polyfill URL
		if (!real_URL.createObjectURL) {
			URL = view.URL = function(uri:any) {
				let
					  uri_info: any = document.createElementNS("http://www.w3.org/1999/xhtml", "a")
					, uri_origin: any
				;
				uri_info.href = uri;
				if (!("origin" in uri_info)) {
					if (uri_info.protocol.toLowerCase() === "data:") {
						uri_info.origin = null;
					} else {
						uri_origin = uri.match(origin);
						uri_info.origin = uri_origin && uri_origin[1];
					}
				}
				return uri_info;
			};
		}
		URL.createObjectURL = function(blob: any): any {
			let
				  type: any = blob.type
				, data_URI_header: any
			;
			if (type === null) {
				type = "application/octet-stream";
			}
			if (blob instanceof FakeBlob) {
				data_URI_header = "data:" + type;
				// @ts-ignore
				if (blob.encoding === "base64") {
					// @ts-ignore
					return data_URI_header + ";base64," + blob.data;
					// @ts-ignore
				} else if (blob.encoding === "URI") {
					// @ts-ignore
					return data_URI_header + "," + decodeURIComponent(blob.data);
				} if (btoa) {
					// @ts-ignore
					return data_URI_header + ";base64," + btoa(blob.data);
				} else {
					// @ts-ignore
					return data_URI_header + "," + encodeURIComponent(blob.data);
				}
			} else if (real_create_object_URL) {
				return real_create_object_URL.call(real_URL, blob);
			}
		};
		URL.revokeObjectURL = function(object_URL: any): void {
			if (object_URL.substring(0, 5) !== "data:" && real_revoke_object_URL) {
				real_revoke_object_URL.call(real_URL, object_URL);
			}
		};
		FBB_proto.append = function(data: any/*, endings*/): void {
			let bb = this.data;
			// decode data to a binary string
			// @ts-ignore
			if (Uint8Array && (data instanceof ArrayBuffer || data instanceof Uint8Array)) {
				let
					  str = ""
					, buf = new Uint8Array(data)
					, i = 0
					, buf_len = buf.length
				;
				for (; i < buf_len; i++) {
					str += String.fromCharCode(buf[i]);
				}
				bb.push(str);
			} else if (get_class(data) === "Blob" || get_class(data) === "File") {
				if (FileReaderSync) {
					let fr = new FileReaderSync;
					bb.push(fr.readAsBinaryString(data));
				} else {
					// async FileReader won't work as BlobBuilder is sync
					// @ts-ignore
					throw new FileException("NOT_READABLE_ERR");
				}
			} else if (data instanceof FakeBlob) {
				// @ts-ignore
				if (data.encoding === "base64" && atob) {
					// @ts-ignore
					bb.push(atob(data.data));
					// @ts-ignore
				} else if (data.encoding === "URI") {
					// @ts-ignore
					bb.push(decodeURIComponent(data.data));
					// @ts-ignore
				} else if (data.encoding === "raw") {
					// @ts-ignore
					bb.push(data.data);
				}
			} else {
				if (typeof data !== "string") {
					data += ""; // convert unsupported types to strings
				}
				// decode UTF-16 to binary string
				bb.push(unescape(encodeURIComponent(data)));
			}
		};
		FBB_proto.getBlob = function(type: any): any {
			if (!arguments.length) {
				type = null;
			}
			// @ts-ignore
			return new FakeBlob(this.data.join(""), type, "raw");
		};
		FBB_proto.toString = function() {
			return "[object BlobBuilder]";
		};
		FB_proto.slice = function(start: any, end: any, type: any): any {
			let args = arguments.length;
			if (args < 3) {
				type = null;
			}
			// @ts-ignore
			return new FakeBlob(
				  this.data.slice(start, args > 1 ? end : this.data.length)
				, type
				, this.encoding
			);
		};
		FB_proto.toString = function() {
			return "[object Blob]";
		};
		FB_proto.close = function() {
			this.size = 0;
			delete this.data;
		};
		return FakeBlobBuilder;
	}(view));

	view.Blob = function(blobParts: any, options: any): any {
		let type = options ? (options.type || "") : "";
		let builder = new BlobBuilder();
		if (blobParts) {
			for (let i = 0, len = blobParts.length; i < len; i++) {
				if (Uint8Array && blobParts[i] instanceof Uint8Array) {
					builder.append(blobParts[i].buffer);
				}
				else {
					builder.append(blobParts[i]);
				}
			}
		}
		let blob = builder.getBlob(type);
		if (!blob.slice && blob.webkitSlice) {
			blob.slice = blob.webkitSlice;
		}
		return blob;
	};

	let getPrototypeOf = Object.getPrototypeOf || function(object: any): any {
		return object.__proto__;
	};
	view.Blob.prototype = getPrototypeOf(new view.Blob());
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this
));